module.exports = __webpack_public_path__ + "b3eae84d703ddb2e980dfa8c0deb8a2d.png";